import { render, staticRenderFns } from "./CookiePopup.vue?vue&type=template&id=7573386a&scoped=true&"
import script from "./CookiePopup.vue?vue&type=script&lang=js&"
export * from "./CookiePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7573386a",
  null
  
)

export default component.exports